import { render, staticRenderFns } from "./Phone.vue?vue&type=template&id=8765735c"
import script from "./Phone.vue?vue&type=script&lang=js"
export * from "./Phone.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports